<template>
    <div>
        <!-- Titulo -->
        <h3 class="mt-1 mb-2 " v-text="titulo"></h3>  
        
        <!-- Tabs -->
        <b-card no-body
                class="my-3" 
                header-bg-variant="primary"
                footer-bg-variant="transparent">
                

                <b-tabs card 
                        v-model="tab">

                    <alert
                        class="alert"
                        :variant="alert.variant"                         
                        :mensagens="alert.mensagens"
                        :value="alert.exibir">
                    </alert> 


                    <b-tab title="Edição">
                        <edicaoform 
                            :edicao="edicaoLocal"
                            :acao="acao"
                            @aposSalvar="aposSalvarEdicao"
                            @formAlterado="formEdicaoAlterado"                            
                        >
                        </edicaoform>                                                  
                    </b-tab>
                    
                    <b-tab title="Atos" :disabled="(!habilitaTabAtos)">
                        <ato :key="edicaoLocal.id"
                             :acao="acao"
                             :edicao="edicaoLocal" 
                             @aposListar="aposListarAtos">
                        </ato>
                    </b-tab>
                </b-tabs>

                <template v-slot:footer >                                  
                    <b-row >  
                        <b-col class="text-left">   
                            <b-button 
                                variant="outline-secondary"                                 
                                @click="voltar"
                            >
                                <i class="fa fa-arrow-left pr-1" ></i>Voltar
                            </b-button>          
                        </b-col>                           
                    </b-row>
                </template>
        </b-card>
    </div>      
</template>

<script>


import edicaoform from "./edicaoForm"
import ato from "./../ato/ato"
import Edicao from '../../../models/Edicao'
import Alert from '../../../models/Alert'

export default {

    components: {
        edicaoform,
        ato 
    },


    props: {                                        
        tabSelecionada: {type: Number, default: 0}
    },

    data(){
        return {
           titulo: 'Edição' ,                      
           tab: 0,
           habilitaTabAtos: false,
           formEdicaoAlt: false,
           edicaoLocal: new Edicao(),    
           acao: this.$route.path.split('/')[3] === 'visualizar' ? 'view' : 'edit',  
           alert: new Alert()      
        }
    },

    methods: {

        obter(id){                 
            return this.$api.edicao.obter(id)
                .then(response => {                                            
                    this.edicaoLocal = new Edicao(response.data.data);                                                                                                                                   
                })
                .catch(error => {
                   this.$helper.showAlert(this.alert, 
                                          this.$constantes.alert.variants.DANGER,
                                          error.response.data.errors); 
                });                             
        },

        voltar(){
            if(this.formEdicaoAlt == true){
                this.$helper.confirmaVoltar(this, 'Existem alterações que não foram salvas. Deseja mesmo sair ?')
                .then(confirmado => { 
                     if(confirmado){
                        this.$router.push({ name: 'edicoes'});
                     } 
                });
            } else {
                this.$router.push({ name: 'edicoes'});
            }
                       
        },

        aposSalvarEdicao(edicao){            
            this.edicaoLocal = new Edicao(edicao);      
            this.habilitarTabs(edicao);                                                                            
        },
        

        habilitarTabs(edicao){    
            this.habilitaTabAtos = edicao.id != null;                                    
        },

        formEdicaoAlterado(param){
            this.formEdicaoAlt = param;
        },

        setAlertAtosPublicacaoPendente(existeAtoPublicacaoPendente){
            var mensagem = "Existem atos com publicação pendente";
            var indice = this.alert.mensagens.findIndex(msg => {
                    return msg === mensagem;
                });

            if(existeAtoPublicacaoPendente){
                if(indice < 0){      
                    this.alert.mensagens.push(mensagem);                       
                    this.$helper.showAlert(this.alert, 
                                           this.$constantes.alert.variants.WARNING,
                                           this.alert.mensagens,
                                           -1);  
                }                       
            }else{
                if(indice >= 0){
                    this.alert.mensagens.splice(indice, 1);                   
                }    
            }
        },

        setAlertAtosParaRepublicar(existeAtoParaRepublicar){        
            var mensagem = 'Existem atos que devem ser republicados';            
            var indice = this.alert.mensagens.findIndex(msg => {
                return msg === mensagem;
            });
                    
            if(existeAtoParaRepublicar){
                if(indice < 0){
                    this.alert.mensagens.push(mensagem); 
                    this.$helper.showAlert(this.alert, 
                                           this.$constantes.alert.variants.WARNING,
                                           this.alert.mensagens,
                                           -1);  
                }
            }else{   
                if(indice >= 0){           
                    this.alert.mensagens.splice(indice, 1);
                }                   
            }  
        },

        aposListarAtos(existeAtoPublicacaoPendente, existeAtoParaRepublicar){               
            this.setAlertAtosPublicacaoPendente(existeAtoPublicacaoPendente);
            this.setAlertAtosParaRepublicar(existeAtoParaRepublicar);
            
            if(this.alert.mensagens.length === 0){
                this.$helper.closeAlert(this.alert);
            } 
        }

    },

    created(){
        if(this.tabSelecionada === 1){            
            this.habilitaTabAtos = true;  
            this.tab = this.tabSelecionada; 
        } 
    },
    
    async mounted(){  
        if(this.$route.params.id === 'new'){
            this.edicaoLocal = new Edicao();
        }else{            
            await this.obter(this.$route.params.id);
        }
        
        if(this.edicaoLocal.id){
            this.habilitarTabs(this.edicaoLocal);                              
        }
    },

}
</script>
<style scoped>
    .alert {
        margin-left: 1.25rem;
        margin-right: 1.25rem;
        margin-top: 0.8rem;
        margin-bottom: -0.4rem;
    }
</style>


